import { getFileTypeByExt } from '@/utils/file/getFileTypeByExt'

import { getFileExt } from '@/utils/file/getFileExt'

export const checkFileType = (fileName: string, fileType: string): boolean => {
  const ext = getFileExt(fileName, false)
  const type = getFileTypeByExt(ext)
  return type === fileType
}
